import styled from "styled-components";

export const Li = styled.li`
    background-color: var(--gray-3);
    width: 350px;
    min-width: 300px;
    height: 270px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    iframe{
        border: none;
    }
    
    a{
        text-decoration: none;
        color: var(--secundary-color);
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 120px;
    }

    p{
        margin-top: 10px;
        font-size: 16px;
        font-weight: 600;
        width: 95%;
        text-align: center;
    }

    a>svg{
        color: var(--white-color);
    }

    svg{
        width: 24px;
        height: 24px;
    }

    @media (max-width: 1250px){
        width: 300px;

        iframe{
            width: 85%;
        }
    }

    @media (max-width: 1024px){
        width: 350px;
    }
`
export const DivVercel = styled.div`
    display: flex;
    width: 80%;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    @media (max-width: 1250px){
        width: 90%;
    }
`